import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Stakeholder, UpdateStakeholderRequest } from "@/types";

export function useUpdateSetStakeholder() {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      updateStakeholderRequest,
    }: {
      id: number;
      updateStakeholderRequest: UpdateStakeholderRequest;
    }) => {
      const path = `companies/${currentCompanyId}/stakeholders/${id.toString()}`;
      const res = await guacHttpClient.patch<
        Stakeholder,
        HttpResponse<Stakeholder>,
        UpdateStakeholderRequest
      >(path, updateStakeholderRequest);
      return res.data;
    },
    onSuccess: (updatedStakeholder) => {
      queryClient.setQueryData(
        ["stakeholders", currentCompanyId],
        (cachedData?: Stakeholder[]) => {
          if (!cachedData) return cachedData;
          return cachedData.map((stakeholder) =>
            stakeholder.id === updatedStakeholder.id
              ? updatedStakeholder
              : stakeholder,
          );
        },
      );
      queryClient.setQueriesData<Stakeholder[]>(
        { queryKey: ["job-stakeholders", currentCompanyId] },
        (cachedData) => {
          if (!cachedData) return cachedData;
          return cachedData.map((stakeholder) =>
            stakeholder.id === updatedStakeholder.id
              ? updatedStakeholder
              : stakeholder,
          );
        },
      );
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });

      void queryClient.invalidateQueries({
        queryKey: ["job-intake", currentCompanyId],
      });

      void queryClient.invalidateQueries({
        queryKey: ["companies-summary"],
      });
    },
  });
}
